// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@/assets/gbIcon/checked.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".myPopover{padding:8px 0}.myPopover .options{padding:0 16px 0 20px;box-sizing:border-box;height:36px;line-height:36px;color:#262626;font-size:14px}.myPopover .options:hover{background-color:#f1f2f4}.myPopover .options.selected{color:#5088ff}.myPopover .options .el-icon-check{background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") 50%;width:20px;height:20px}.myPopover .options .el-icon-check:before{content:\"\"}", ""]);
// Exports
module.exports = exports;
